/**
 * 后台-组织管理
 */
'use strict';
angular.module("userDisplayModule", []).
controller('userDisplayCtrl', ['$scope', 'httpService', 'userInformationService','modalDialog', function ($scope, httpService, userInformationService,modalDialog) {
  initStatus();
  initData();
  //初始化数据
  function initStatus() {
    $scope.status = {
      //下拉框数据
      statusOptions: [{
        name: "全部状态",
        value: ''
      }, {
        name: "正常",
        value: 0
      }, {
        name: "停用",
        value: 1,
      }],
      keywords: ''
      //搜索框val
    }
    $scope.status.selectedStatus = angular.copy($scope.status.statusOptions[0]);
    $scope.data = {
      listData: [], //列表数据
      selectedArray: [], //选中的数据
    }
    $scope.page = {
      "CURRPAGE": 1,
      "PAGESIZE": 20,
      "ITEMCOUNT": 0
    };
  }
  //初始化操作
  function initData() {
    requestData();
  }
  /**
   * 请求table数据
   */
  function requestData() {
    var params = {
      currPage: $scope.page.CURRPAGE,
      pageSize: $scope.page.PAGESIZE,
      searchword: $scope.status.keywords,
      status: $scope.status.selectedStatus.value
    }
    $scope.loadingPromise=httpService.http('/mcnadmin/admin/user/list.do', params, 'post').then(function (res) {
      $scope.data.listData = res.data.ldata;
	      $scope.page = {
	        CURRPAGE: res.data.startPage,
	        PAGESIZE: res.data.pageSize,
	        ITEMCOUNT: res.data.totalResults,
	        PAGECOUNT: res.data.totalPages
	      };
    })
  }
  /**
   * input搜索
   */
  $scope.clickSearch = function () {
    requestData();
  }
  /**
   * [selectPanel description] 全选当前面板的稿件
   * @param  {[type]} items [description] 当前面板
   * @return {[type]}       [description]
   */
  $scope.selectPanel = function (items) {
    if ($scope.data.listData.length > 0 && $scope.data.selectedArray.length == $scope.data.listData.length) {
      $scope.data.selectedArray = [];
    } else {
      $scope.data.selectedArray = [].concat($scope.data.listData);
    }
  };
  /**
   * [selectDoc description] 单选
   * @param  {[type]} item [description] 当前数据
   * @return {[type]}      [description]
   */
  $scope.selectNotice = function (item) {
    var index = $scope.data.selectedArray.indexOf(item);
    index > -1 ? $scope.data.selectedArray.splice(index, 1) : $scope.data.selectedArray.push(item);
  };
  /**
   * [roleSetting description] -角色设置
   * @return {[type]} [description]
   */
  $scope.roleSetting = function (userId) {
    userInformationService.roleSetting(userId).then(function (data) {
      var params = {
        roleIds: data,
        userId: userId
      }
      $scope.loadingPromise = httpService.http("/mcnadmin/admin/role/addUserRoles.do", params, "post").then(function (data) {
        modalDialog.alertType('', '添加角色成功', 'success');
        requestData();
      });
    });
  };

}]);
